module.exports = __webpack_public_path__ + "static/media/Airtel.59ba7456.svg";